/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-26T17:22:28+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-26T17:26:03+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * AHeadlineDialog - …
**/

class AHeadlineDialog extends Component {
  render() {
    const {
      style,
      children,
    } = this.props;
		 return (
      <h3 className="a-headline a-headline-dialog" style={style}>{children}</h3>
    	);
  }
}

AHeadlineDialog.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
};
AHeadlineDialog.defaultProps = {};
export default AHeadlineDialog;

